// import React, { useEffect, useState } from 'react';
// import { Trash2, Filter, X, Plus } from "lucide-react";

// const FilterComponent = ({ attributes, onApply, activeFilters }) => {
//   const [filters, setFilters] = useState([{ key: "", value: "" }]);
//   const [isOpen, setIsOpen] = useState(false);

//   // Initialize filters from activeFilters when component mounts
//   useEffect(() => {
//     if (Object.keys(activeFilters).length > 0) {
//       const initialFilters = Object.entries(activeFilters).map(
//         ([key, value]) => ({
//           key,
//           value,
//         })
//       );
//       setFilters(
//         initialFilters.length > 0 ? initialFilters : [{ key: "", value: "" }]
//       );
//     } else {
//       setFilters([{ key: "", value: "" }]);
//     }
//   }, [activeFilters]);

//   const handleChange = (index, field, newValue) => {
//     const updated = [...filters];
//     updated[index][field] = newValue;
//     setFilters(updated);
//   };

//   const addFilter = () => {
//     setFilters([...filters, { key: "", value: "" }]);
//   };

//   const removeFilter = (index) => {
//     if (filters.length > 1) setFilters(filters.filter((_, i) => i !== index));
//   };


//   const applyFilters = () => {
//     const validFilters = filters.filter(
//       f => f.key && f.operator && (f.operator.includes("has") || f.value)
//     );

//     onApply(validFilters);
//     setIsOpen(false);
//   };


//   const clearFilters = () => {
//     setFilters([{ key: "", value: "" }]);
//     onApply({});
//     setIsOpen(false);
//   };

//   const activeFilterCount = Object.keys(activeFilters).length;
//   const safeAttributes = Array.isArray(attributes) ? attributes : [];

//   const DEFAULT_OPERATORS = ["is", "is not", "contains", "contains not", "has", "has not"];

//   return (
//     <>
//       {/* Filter Button */}
//       <div className="">
//         <button
//           onClick={() => setIsOpen(true)}
//           className="flex items-center gap-2 px-4 py-2.5 border border-gray-300 rounded-lg bg-white shadow-sm hover:shadow-md hover:bg-gray-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-500"
//         >
//           <Filter className="w-5 h-5 text-green-500" />
//           <span className="text-gray-700 font-medium text-md">Filters</span>
//           {activeFilterCount > 0 && (
//             <span className="ml-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full shadow">
//               {activeFilterCount}
//             </span>
//           )}
//         </button>
//       </div>


//       {/* Filter Modal */}
//       {isOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col">
//             {/* Modal Header */}
//             <div className="flex items-center justify-between p-5 border-b border-gray-200">
//               <div className="flex items-center gap-3">
//                 <Filter className="w-5 h-5 text-gray-600" />
//                 <h2 className="text-lg font-semibold text-gray-800">Filter Contacts</h2>
//                 {activeFilterCount > 0 && (
//                   <span className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full">
//                     {activeFilterCount} active
//                   </span>
//                 )}
//               </div>
//               <button
//                 onClick={() => setIsOpen(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <X className="w-5 h-5" />
//               </button>
//             </div>

//             {/* Modal Body */}
//             <div className="p-5 overflow-y-auto flex-1">
//               {safeAttributes.length > 0 ? (
//                 <div className="space-y-3">
//                   {filters.map((filter, index) => (
//                     <div key={index} className="flex items-center gap-3 flex-wrap">
//                       {/* Attribute Dropdown */}
//                       <select
//                         className="border border-gray-300 px-3 py-2 rounded min-w-[120px] flex-none focus:outline-none focus:ring-2 focus:ring-green-500"
//                         value={filter.key}
//                         onChange={(e) => {
//                           const newKey = e.target.value;
//                           handleChange(index, "key", newKey);

//                           handleChange(index, "operator", "is");
//                         }}

//                       >
//                         <option value="">Select Attribute</option>
//                         {safeAttributes.map((attr, i) => (
//                           <option key={i} value={attr}>
//                             {attr}
//                           </option>
//                         ))}
//                       </select>

//                       {/* Operator Dropdown */}
//                       <select
//                         className="border border-gray-300 px-3 py-2 rounded min-w-[100px] flex-none focus:outline-none focus:ring-2 focus:ring-green-500"
//                         value={filter.operator || ""}
//                         onChange={(e) => handleChange(index, "operator", e.target.value)}
//                       >
//                         {filter.key ? (
//                           DEFAULT_OPERATORS.map((op, i) => (
//                             <option key={i} value={op}>
//                               {op}
//                             </option>
//                           ))
//                         ) : (
//                           <option value="">Select operator</option>
//                         )}
//                       </select>


//                       {/* Value Input */}
//                       <input
//                         className="border border-gray-300 px-3 py-2 rounded flex-1 min-w-[120px] focus:outline-none focus:ring-2 focus:ring-green-500"
//                         placeholder="Enter value"
//                         value={filter.value}
//                         onChange={(e) => handleChange(index, "value", e.target.value)}
//                       />

//                       {/* Remove Button */}
//                       <button
//                         onClick={() => removeFilter(index)}
//                         className="p-2 bg-red-50 text-red-600 rounded hover:bg-red-100 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
//                         disabled={filters.length === 1}
//                       >
//                         <Trash2 className="w-4 h-4" />
//                       </button>
//                     </div>

//                   ))}


//                   <button
//                     onClick={addFilter}
//                     className="flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded hover:bg-blue-100 transition-colors border border-blue-200"
//                   >
//                     <Plus className="w-4 h-4" />
//                     Add Another Filter
//                   </button>
//                 </div>
//               ) : (
//                 <p className="text-sm text-gray-500 text-center py-8">
//                   No attributes available for filtering
//                 </p>
//               )}
//             </div>

//             {/* Modal Footer */}
//             <div className="flex items-center justify-between p-5 border-t border-gray-200 bg-gray-50">
//               <button
//                 onClick={clearFilters}
//                 className="flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded transition-colors"
//               >
//                 <X className="w-4 h-4" />
//                 Clear All Filters
//               </button>
//               <div className="flex gap-3">
//                 <button
//                   onClick={() => setIsOpen(false)}
//                   className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={applyFilters}
//                   className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
//                 >
//                   Apply Filters
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//     </>
//   );
// };

// export default FilterComponent;




import React, { useEffect, useState } from "react";
import { Trash2, Filter, X, Plus } from "lucide-react";

const DEFAULT_OPERATORS = ["is", "is not", "contains", "contains not", "has", "has not"];

const FilterComponent = ({ attributes, onApply, activeFilters }) => {
  const [filters, setFilters] = useState([{ key: "", operator: "is", value: "" }]);
  const [isOpen, setIsOpen] = useState(false);

  // Initialize filters from activeFilters safely
  useEffect(() => {
    if (activeFilters && Object.keys(activeFilters).length > 0) {
      const initialFilters = Object.entries(activeFilters).map(([_, f]) => ({
        key: f.key || "",
        operator: f.operator || "is",
        value: f.value !== undefined ? f.value : "",
      }));
      setFilters(initialFilters.length > 0 ? initialFilters : [{ key: "", operator: "is", value: "" }]);
    } else {
      setFilters([{ key: "", operator: "is", value: "" }]);
    }
  }, [activeFilters]);

  const handleChange = (index, field, newValue) => {
    const updated = [...filters];
    updated[index][field] = newValue;
    setFilters(updated);
  };

  const addFilter = () => {
    setFilters([...filters, { key: "", operator: "is", value: "" }]);
  };

  const removeFilter = (index) => {
    if (filters.length > 1) setFilters(filters.filter((_, i) => i !== index));
  };

  const applyFilters = () => {
    const validFilters = filters.filter(
      f => f.key && f.operator && (f.operator.includes("has") || String(f.value).trim() !== "")
    );
    onApply(validFilters);
    setIsOpen(false);
  };

  const clearFilters = () => {
    setFilters([{ key: "", operator: "is", value: "" }]);
    onApply([]);
    setIsOpen(false);
  };

  const activeFilterCount = filters.filter(f => f.key && f.operator && f.value).length;
  const safeAttributes = Array.isArray(attributes) ? attributes : [];

  return (
    <>
      {/* Filter Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="flex items-center gap-2 px-4 py-2.5 border border-gray-300 rounded-lg bg-white shadow-sm hover:shadow-md hover:bg-gray-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-500"
      >
        <Filter className="w-5 h-5 text-green-500" />
        <span className="text-gray-700 font-medium text-md">Filters</span>
        {activeFilterCount > 0 && (
          <span className="ml-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full shadow">
            {activeFilterCount}
          </span>
        )}
      </button>

      {/* Filter Modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-5 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <Filter className="w-5 h-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-800">Filter Contacts</h2>
                {activeFilterCount > 0 && (
                  <span className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full">
                    {activeFilterCount} active
                  </span>
                )}
              </div>
              <button onClick={() => setIsOpen(false)} className="text-gray-500 hover:text-gray-700">
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-5 overflow-y-auto flex-1">
              {safeAttributes.length > 0 ? (
                <div className="space-y-3">
                  {filters.map((filter, index) => (
                    <div key={index} className="flex items-center gap-3 flex-wrap">
                      {/* Attribute Dropdown */}
                      <select
                        className="border border-gray-300 px-3 py-2 rounded min-w-[120px] flex-none focus:outline-none focus:ring-2 focus:ring-green-500"
                        value={filter.key}
                        onChange={(e) => {
                          handleChange(index, "key", e.target.value);
                          handleChange(index, "operator", "is");
                        }}
                      >
                        <option value="">Select Attribute</option>
                        {safeAttributes.map((attr, i) => (
                          <option key={i} value={attr}>
                            {attr}
                          </option>
                        ))}
                      </select>

                      {/* Operator Dropdown */}
                      <select
                        className="border border-gray-300 px-3 py-2 rounded min-w-[100px] flex-none focus:outline-none focus:ring-2 focus:ring-green-500"
                        value={filter.operator}
                        onChange={(e) => handleChange(index, "operator", e.target.value)}
                      >
                        {filter.key ? (
                          DEFAULT_OPERATORS.map((op, i) => (
                            <option key={i} value={op}>
                              {op}
                            </option>
                          ))
                        ) : (
                          <option value="">Select operator</option>
                        )}
                      </select>

                      {/* Value Input */}
                      <input
                        className="border border-gray-300 px-3 py-2 rounded flex-1 min-w-[120px] focus:outline-none focus:ring-2 focus:ring-green-500"
                        placeholder="Enter value"
                        value={String(filter.value)}
                        onChange={(e) => handleChange(index, "value", e.target.value)}
                      />

                      {/* Remove Button */}
                      <button
                        onClick={() => removeFilter(index)}
                        className="p-2 bg-red-50 text-red-600 rounded hover:bg-red-100 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                        disabled={filters.length === 1}
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  ))}

                  <button
                    onClick={addFilter}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded hover:bg-blue-100 transition-colors border border-blue-200"
                  >
                    <Plus className="w-4 h-4" />
                    Add Another Filter
                  </button>
                </div>
              ) : (
                <p className="text-sm text-gray-500 text-center py-8">
                  No attributes available for filtering
                </p>
              )}
            </div>

            {/* Modal Footer */}
            <div className="flex items-center justify-between p-5 border-t border-gray-200 bg-gray-50">
              <button
                onClick={clearFilters}
                className="flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded transition-colors"
              >
                <X className="w-4 h-4" />
                Clear All Filters
              </button>
              <div className="flex gap-3">
                <button
                  onClick={() => setIsOpen(false)}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={applyFilters}
                  className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
                >
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FilterComponent;
